// src/components/MethodPanel.jsx (s133, PHASE 5a, DECISIONS #45) — what this city's own water means for
// the method: final rinse, what the residue is, pure-water gear, and the hot months where they collide.
// Computed by src/data/methodVerdicts.js from figures already on the page; every cell is a short
// fragment (gated) and the reasoning lives once, on /methodology#method.
import React from 'react';
import { Link } from 'react-router-dom';
import { methodVerdicts } from '../data/methodVerdicts.js';

export default function MethodPanel({ city, climate, T, fontBody, fontMono }) {
  const rows = methodVerdicts(city, climate);
  if (!rows.length) return null;
  const label = { fontFamily: fontMono, fontSize: 11, letterSpacing: '0.18em', color: T.sienna, marginBottom: 12 };
  return (
    <div data-region="method-panel" style={{ marginTop: 40 }}>
      <div style={label}>WHAT THIS WATER MEANS FOR THE METHOD</div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px 36px' }}>
        {rows.map((r) => (
          <div key={r.key} data-method={r.key} data-level={r.level} style={{ minWidth: 170, maxWidth: 260 }}>
            <div style={{ fontFamily: fontMono, fontSize: 10, letterSpacing: '0.12em', color: T.inkSoft }}>{r.label.toUpperCase()}</div>
            <div style={{ fontFamily: fontMono, fontSize: 20, color: T.ink, margin: '2px 0' }}>{r.verdict}</div>
            <div style={{ fontFamily: fontMono, fontSize: 11, color: T.inkSoft }}>{r.basis}</div>
            <div style={{ fontFamily: fontBody, fontSize: 13, color: T.inkSoft }}>
              <Link to={`/methodology#method-${r.key}`} style={{ color: 'inherit' }}>{r.note}</Link>
            </div>
          </div>
        ))}
      </div>
      <p style={{ fontFamily: fontMono, fontSize: 11, margin: '10px 0 0' }}>
        <Link to="/methodology#method" style={{ color: T.inkSoft }}>How these calls are made</Link>
      </p>
    </div>
  );
}
